import React, { useContext } from "react";
import ButtonStyleProps from "../interfaces/ButtonStyleProps";
import StyledButtonCircle from "./StyledButtonCircle";
import { useNavigate } from "react-router-dom";
import StylesContext from "../context/StylesContext";

const ButtonLang: React.FC<ButtonStyleProps> = ({
  svgWidth,
  fillCircleBtn,
  fillSymbolBtn,
  circleBorderColor,
}) => {
  const { styles, setStyles } = useContext(StylesContext);

  const history = useNavigate();
  const handleClick = () => {
     history(`/cardapio/${styles.urlId}/languages`)
  };
  return (
    <StyledButtonCircle $circlecolor={circleBorderColor || "#024900"}>
      <button className="buttons_home_page" onClick={handleClick}>
        <svg
          width={svgWidth || "150"}
          height={svgWidth || "150"}
          viewBox="0 0 300 300"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
            <path
              d="M150 300C232.851 300 300 232.851 300 150C300 67.1492 232.851 0 150 0C67.1492 0 0 67.1492 0 150C0 232.851 67.1492 300 150 300Z"
              fill={ fillCircleBtn || "#48302F" }
            />
            <path
              d="M149.955 165.718C152.407 165.718 154.587 164.173 155.495 161.72C156.494 158.722 154.859 155.451 151.862 154.361C146.14 152.453 140.69 149.909 135.604 147.002C146.231 135.191 149.319 121.017 149.864 107.844H161.58C164.759 107.844 167.393 105.3 167.393 102.029C167.393 98.7582 164.759 96.2143 161.58 96.2143H132.698V90.3996C132.698 87.2197 130.064 84.585 126.885 84.585C123.706 84.585 121.072 87.1289 121.072 90.3996V96.2143H92.1889C89.0099 96.2143 86.376 98.7582 86.376 102.029C86.376 105.3 88.9191 107.844 92.1889 107.844H138.329C137.784 119.655 134.968 131.102 125.886 140.46C119.164 135.191 113.261 129.013 108.628 122.017C106.812 119.382 103.27 118.655 100.636 120.381C98.0018 122.199 97.2752 125.742 99.0009 128.377C103.815 135.645 109.809 142.096 116.621 147.729C112.534 150.272 107.72 152.453 101.998 154.361C99.0009 155.36 97.366 158.631 98.3651 161.72C99.1825 164.082 101.453 165.627 103.815 165.627C106.176 165.627 104.995 165.536 105.631 165.354C114.078 162.538 120.89 158.994 126.521 154.997C133.242 159.267 140.509 162.719 148.229 165.354C148.865 165.536 149.5 165.627 150.045 165.627L149.955 165.718Z"
              fill={ fillSymbolBtn || "#CFC5B2" }
            />
            <path
              d="M212.988 203.604L184.105 145.73C182.107 141.823 175.749 141.823 173.751 145.73L144.868 203.604C143.415 206.42 144.596 209.964 147.502 211.326C150.408 212.78 153.86 211.599 155.222 208.783L162.307 194.609H195.64L202.724 208.783C203.724 210.781 205.813 211.962 207.902 211.962C209.991 211.962 209.627 211.781 210.445 211.326C213.26 209.873 214.441 206.42 212.988 203.513V203.604ZM168.029 183.071L178.928 161.266L189.827 183.071H168.029Z"
              fill={ fillSymbolBtn || "#CFC5B2" }
            />

        </svg>
      </button>
    </StyledButtonCircle>
  );
};

export default ButtonLang;
